const States = [
  { Full: 'Alabama', Abbr: 'AL' },
  { Full: 'Alaska', Abbr: 'AK' },
  { Full: 'American Samoa', Abbr: 'AS' },
  { Full: 'Arizona', Abbr: 'AZ' },
  { Full: 'Arkansas', Abbr: 'AR' },
  { Full: 'California', Abbr: 'CA' },
  { Full: 'Colorado', Abbr: 'CO' },
  { Full: 'Connecticut', Abbr: 'CT' },
  { Full: 'Delaware', Abbr: 'DE' },
  { Full: 'District of Columbia', Abbr: 'DC' },
  { Full: 'Florida', Abbr: 'FL' },
  { Full: 'Georgia', Abbr: 'GA' },
  { Full: 'Guam', Abbr: 'GU' },
  { Full: 'Hawaii', Abbr: 'HI' },
  { Full: 'Idaho', Abbr: 'ID' },
  { Full: 'Illinois', Abbr: 'IL' },
  { Full: 'Indiana', Abbr: 'IN' },
  { Full: 'Iowa', Abbr: 'IA' },
  { Full: 'Kansas', Abbr: 'KS' },
  { Full: 'Kentucky', Abbr: 'KY' },
  { Full: 'Louisiana', Abbr: 'LA' },
  { Full: 'Maine', Abbr: 'ME' },
  { Full: 'Maryland', Abbr: 'MD' },
  { Full: 'Massachusetts', Abbr: 'MA' },
  { Full: 'Michigan', Abbr: 'MI' },
  { Full: 'Minnesota', Abbr: 'MN' },
  { Full: 'Mississippi', Abbr: 'MS' },
  { Full: 'Missouri', Abbr: 'MO' },
  { Full: 'Montana', Abbr: 'MT' },
  { Full: 'Nebraska', Abbr: 'NE' },
  { Full: 'Nevada', Abbr: 'NV' },
  { Full: 'New Hampshire', Abbr: 'NH' },
  { Full: 'New Jersey', Abbr: 'NJ' },
  { Full: 'New Mexico', Abbr: 'NM' },
  { Full: 'New York', Abbr: 'NY' },
  { Full: 'North Carolina', Abbr: 'NC' },
  { Full: 'North Dakota', Abbr: 'ND' },
  { Full: 'Ohio', Abbr: 'OH' },
  { Full: 'Oklahoma', Abbr: 'OK' },
  { Full: 'Oregon', Abbr: 'OR' },
  { Full: 'Pennsylvania', Abbr: 'PA' },
  { Full: 'Puerto Rico', Abbr: 'PR' },
  { Full: 'Rhode Island', Abbr: 'RI' },
  { Full: 'South Carolina', Abbr: 'SC' },
  { Full: 'South Dakota', Abbr: 'SD' },
  { Full: 'Tennessee', Abbr: 'TN' },
  { Full: 'Texas', Abbr: 'TX' },
  { Full: 'Utah', Abbr: 'UT' },
  { Full: 'Vermont', Abbr: 'VT' },
  { Full: 'Virgin Islands', Abbr: 'VI' },
  { Full: 'Virginia', Abbr: 'VA' },
  { Full: 'Washington', Abbr: 'WA' },
  { Full: 'West Virginia', Abbr: 'WV' },
  { Full: 'Wisconsin', Abbr: 'WI' },
  { Full: 'Wyoming', Abbr: 'WY' },
];

export default States;
